export const BETTERSTACK_MAINTENANCE_STATUS_PAGE_ID =
  process.env.BETTERSTACK_MAINTENANCE_STATUS_PAGE_ID ?? '166126';

export const BETTERSTACK_MAINTENANCE_STATUS_REPORTS_URL =
  `https://uptime.betterstack.com/api/v2/status-pages/${BETTERSTACK_MAINTENANCE_STATUS_PAGE_ID}/status-reports`;

export const MAINTENANCE_STATUS_URL =
  process.env.NEXT_PUBLIC_MAINTENANCE_STATUS_URL ?? 'https://status.roomster.com/';

export const MAINTENANCE_STATUS_API_PATH = '/react18/api/maintenance-status';

export const MAINTENANCE_STATUS_POLL_INTERVAL_MS = 5 * 60 * 1000;
export const MAINTENANCE_STATUS_REQUEST_TIMEOUT_MS = 4000;
